import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { AuthContext } from './../../Context/AuthContext.js';
import { getRoleHome } from './../../helpers/roleHome.js';

// Пускает только перечисленные роли, остальных уводит на их домашнюю страницу.
// Ставится внутрь RequireAuth, так что user уже есть.
function RequireRole({ roles }) {
    const { user } = useContext(AuthContext);

    if (!user || !roles.includes(user.role)) {
        return <Navigate to={getRoleHome(user?.role)} replace />;
    }

    return <Outlet />;
}

export default RequireRole;
